/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Tickets_Tab_ClosedInputs */

const en_admin_tickets_tab_closed = /** @type {(inputs: Admin_Tickets_Tab_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Closed`)
};

const zh_admin_tickets_tab_closed = /** @type {(inputs: Admin_Tickets_Tab_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已关闭`)
};

/**
* | output |
* | --- |
* | "Closed" |
*
* @param {Admin_Tickets_Tab_ClosedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_tickets_tab_closed = /** @type {((inputs?: Admin_Tickets_Tab_ClosedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Tickets_Tab_ClosedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_tickets_tab_closed(inputs)
	return zh_admin_tickets_tab_closed(inputs)
});
export { admin_tickets_tab_closed as "admin.tickets.tab_closed" }